export function targetCurrencySymbol (context, accountingOrganisationId) {
  if (context.currencySymbol !== 'XXX') return context.currencySymbol

  // We always load data in a specific currency, so that we can cache based on the endpoint url
  const baseCurrency = entityBaseCurrency(context, accountingOrganisationId)
  if (baseCurrency) return baseCurrency

  return defaultCurrencySymbol(context)
}

function entityBaseCurrency (context, accountingOrganisationId) {
  if (!accountingOrganisationId) return
  const accountingOrganisation = context.browserAppAccount.data.entities.find(o => o.id === accountingOrganisationId)
  return accountingOrganisation?.base_currency
}

export function defaultCurrencySymbol (context) {
  return context.browserAppAccount.data?.entities?.find(function (o) {
    if (!o.base_currency) return false
    return true
  })?.base_currency
}
